import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit, } from '@angular/core';
import { Setting } from '@app-state';
import { enumMapper, USER_ICON_MAP, UserType, } from '@models';
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { MapperService, RoleService, } from '@services';
import { extractErrorMessage } from '@utils/object.utils';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
var RoleUserSource = /** @class */ (function () {
    function RoleUserSource(_roleService) {
        this._roleService = _roleService;
    }
    Object.defineProperty(RoleUserSource.prototype, "mapper", {
        get: function () {
            return MapperService.userMap;
        },
        enumerable: true,
        configurable: true
    });
    RoleUserSource.prototype.get = function (qo) {
        return this._roleService.getUsersIn(this.roleId, qo);
    };
    return RoleUserSource;
}());
export { RoleUserSource };
var RoleUsersGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RoleUsersGridComponent, _super);
    function RoleUsersGridComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.UserIconMap = USER_ICON_MAP;
        _this.isWindowsAuthenticationEnabled = _this._appState.settings.get(Setting.isWindowsAuthEnabled);
        _this.close = new EventEmitter();
        _this.isInConflictingState$ = new Subject();
        _this.typeList = enumMapper(UserType, {
            resourceKey: 'UserType',
        });
        _this.defaultType = _this.isWindowsAuthenticationEnabled
            ? undefined
            : _this.typeList.find(function (x) { return x.value === UserType.User.toString(); });
        _this._roleService = _this._injector.get(RoleService);
        return _this;
    }
    Object.defineProperty(RoleUsersGridComponent.prototype, "roleId", {
        set: function (value) {
            if (value == null) {
                return;
            }
            this._service.roleId = value;
            this._roleId = value;
            this._refresh$.next();
        },
        enumerable: true,
        configurable: true
    });
    RoleUsersGridComponent.prototype.ngOnInit = function () {
        var _this = this;
        try {
            this._roleService
                .getUserIdsForRole(this._roleId)
                .pipe(takeUntil(this._destroyed$))
                .subscribe(function (ids) {
                var _a;
                (_a = _this._grid.selectionManager).select.apply(_a, ids);
                _this._grid.selectionManager.snapshot();
            });
        }
        catch (e) {
            this._snack.error(extractErrorMessage(e));
        }
    };
    RoleUsersGridComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.close.complete();
    };
    RoleUsersGridComponent.prototype.onSubmit = function () {
        var _this = this;
        this.isInConflictingState$.next(false);
        this._roleService
            .setUsers(this._roleId, this._grid.selectionManager.difference)
            .subscribe(function () { return _this.close.next(); }, function (errorResponse) {
            var _a;
            if (errorResponse.status === 409) {
                _this.isInConflictingState$.next(true);
                var failedItems = errorResponse
                    .error
                    .resourceIds
                    .map(function (id) { return ({ id: id }); });
                // remove the no longer unavailable user ids from the selection
                (_a = _this._grid.selectionManager).deselect.apply(_a, failedItems);
                _this._refresh$.next();
            }
        });
    };
    return RoleUsersGridComponent;
}(ODataGridComponent));
export { RoleUsersGridComponent };
